import { render } from "./EditAppointmentForm.vue?vue&type=template&id=5b161c40"
import script from "./EditAppointmentForm.vue?vue&type=script&lang=js"
export * from "./EditAppointmentForm.vue?vue&type=script&lang=js"

import "./EditAppointmentForm.vue?vue&type=style&index=0&id=5b161c40&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__